"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _utils = require("../theme/utils");

var _colors = require("../theme/colors");

var _createStyles = _interopRequireDefault(require("../createStyles"));

var _Button = _interopRequireDefault(require("../Button"));

var _excluded = ["children", "size", "type", "onClick", "isLoading", "disabled", "className", "jss"];
var useStyles = (0, _createStyles["default"])(function (theme) {
  return {
    root: {
      minWidth: 95
    },
    secondary: {
      color: theme.palette.secondary["default"],
      boxShadow: '0 0 3px 0 rgba(0, 2, 3, 0.25)',
      background: _colors.white,
      '&:hover': {
        color: theme.palette.primary["default"]
      },
      '&:disabled': {
        color: (0, _utils.fade)(theme.palette.secondary["default"], 0.3)
      }
    },
    error: {
      color: _colors.white,
      backgroundColor: theme.palette.error["default"],
      '&:not([disabled]):hover': {
        backgroundColor: function backgroundColor(_ref) {
          var isLoading = _ref.isLoading;
          return (0, _utils.fade)(theme.palette.error["default"], isLoading ? 1 : 0.85);
        }
      },
      '&:disabled': {
        backgroundColor: (0, _utils.fade)(theme.palette.error["default"], 0.7),
        color: (0, _utils.fade)(_colors.white, 0.8)
      }
    },
    success: {
      color: _colors.white,
      backgroundColor: theme.palette.success["default"],
      '&:not([disabled]):hover': {
        backgroundColor: function backgroundColor(_ref2) {
          var isLoading = _ref2.isLoading;
          return (0, _utils.fade)(theme.palette.success["default"], isLoading ? 1 : 0.85);
        }
      },
      '&:disabled': {
        backgroundColor: (0, _utils.fade)(theme.palette.success["default"], 0.7),
        color: (0, _utils.fade)(_colors.white, 0.8)
      }
    }
  };
}, {
  name: 'FlatButton'
});
exports.useStyles = useStyles;

var FlatButton = /*#__PURE__*/_react["default"].forwardRef(function FlatButton(_ref3, ref) {
  var _cn;

  var children = _ref3.children,
      _ref3$size = _ref3.size,
      size = _ref3$size === void 0 ? 'md' : _ref3$size,
      _ref3$type = _ref3.type,
      type = _ref3$type === void 0 ? null : _ref3$type,
      onClick = _ref3.onClick,
      _ref3$isLoading = _ref3.isLoading,
      isLoading = _ref3$isLoading === void 0 ? false : _ref3$isLoading,
      _ref3$disabled = _ref3.disabled,
      disabled = _ref3$disabled === void 0 ? false : _ref3$disabled,
      className = _ref3.className,
      jss = _ref3.jss,
      props = (0, _objectWithoutProperties2["default"])(_ref3, _excluded);
  var classes = useStyles({
    isLoading: isLoading,
    jss: jss
  });
  var spinnerColor = type !== null ? 'white' : 'blue';
  var rippleColor = type !== null ? _colors.white : _colors.gray400;
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, props, {
    disabled: disabled,
    isLoading: isLoading,
    onClick: onClick,
    size: size,
    rippleColor: rippleColor,
    spinnerColor: spinnerColor,
    className: (0, _classnames["default"])(classes.root, (_cn = {}, (0, _defineProperty2["default"])(_cn, classes["".concat(type)], type !== null), (0, _defineProperty2["default"])(_cn, classes.secondary, type === null), _cn), className),
    ref: ref
  }), children);
});

FlatButton.displayName = 'FlatButton';
var _default = FlatButton;
exports["default"] = _default;